var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c('div',{staticClass:"formio-component formio-component-content",domProps:{"innerHTML":_vm._s(_vm.exportMetadata.ComponentTree.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }